import { render } from "./SettingDrawer.vue?vue&type=template&id=957f377a&scoped=true"
import script from "./SettingDrawer.vue?vue&type=script&lang=js"
export * from "./SettingDrawer.vue?vue&type=script&lang=js"

import "./SettingDrawer.vue?vue&type=style&index=0&id=957f377a&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-957f377a"]])

export default __exports__